import { useMemo } from 'react';
import useSocketRegistrationInfo from './useSocketRegistrationInfo';
import useSocketConnection from './socket/useSocketConnection';

export default function useAppSockets() {
  const { userId, deviceToken, location, isLoggedIn } = useSocketRegistrationInfo();
  const socket = useSocketConnection({ deviceToken, userId, location });

  // Return memoized socket to prevent parent re-renders
  return useMemo(() => ({ socket }), [socket]);
}
